import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getResourceLibraryMetadata } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibratyMetadata/getResourceLibraryMetadataApi";
import { ResourceLibraryMetadataFilters } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibratyMetadata/types";

interface PodcastsMetadataState {
  metadata: ResourceLibraryMetadataFilters | null;
  loadingGet: boolean;
  error: string | null;
}

const initialState: PodcastsMetadataState = {
  metadata: null,
  loadingGet: false,
  error: null,
};

export const getPodcastsMetadataAction = createAsyncThunk(
  "podcastsMetadata/get",
  async () => {
    const response = await getResourceLibraryMetadata();
    return response.data.filters;
  },
);

const podcastsMetadataSlice = createSlice({
  name: "podcastsMetadata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPodcastsMetadataAction.pending, (state) => {
        state.loadingGet = true;
        state.error = null;
      })
      .addCase(getPodcastsMetadataAction.fulfilled, (state, action) => {
        state.metadata = action.payload;
        state.loadingGet = false;
      })
      .addCase(getPodcastsMetadataAction.rejected, (state, action) => {
        state.loadingGet = false;
        state.error = action.error.message || "Failed to fetch metadata";
      });
  },
});

export default podcastsMetadataSlice.reducer;
